import { ClickAway } from '@components/core-ui/ClickAway';
import AddBlue from '@components/icons/AddBlue.svg';
import SixDots from '@components/icons/SixDots.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { routes } from '@routes';
import { MeResponseDtoOrganization } from 'app/API';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { CurrentOrganizationRow } from './components/CurrentOrganizationRow';
import { OrganizationRow } from './components/OrganizationRow';

export const OrganizationList = () => {
  const [orgListOpen, setOrgListOpen] = useState(false);
  const { me, organization } = useAuthContext();

  const navigate = useNavigate();

  const { openModal } = useModalContext();

  const handleOrganizationClick = (org: MeResponseDtoOrganization) => {
    setOrgListOpen(false);
    navigate(routes.dashboard.make(org.slug));
  };

  const handleCreateOrganization = () => {
    setOrgListOpen(false);
    openModal(ModalNamesEnum.NewOrganizationModal);
  };

  return (
    <div className="mb-2.5">
      <ClickAway onClickAway={() => setOrgListOpen(false)}>
        {organization ? (
          <CurrentOrganizationRow
            organization={organization}
            setOrgListOpen={setOrgListOpen}
            orgListOpen={orgListOpen}
          />
        ) : null}
        {organization ? (
          <div className={`relative ${orgListOpen ? '' : 'hidden'}`}>
            <div className="w-full h-auto max-h-52 overflow-y-auto absolute z-30 bg-surface shadow-xl">
              <ul className="py-1 overflow-hidden">
                {me.organizations
                  ? me.organizations
                      .filter((org) => org.id !== organization.id)
                      .map((org, index: number) => (
                        <OrganizationRow key={index} org={org} handleOrganizationClick={handleOrganizationClick} />
                      ))
                  : null}
                <li className="h-9 cursor-pointer text-foreground-muted text-base hover:bg-surface-muted flex flex-row">
                  <RouterLink
                    to={routes.organizationsList.pattern}
                    onClick={() => setOrgListOpen(false)}
                    className="text-foreground-muted rounded-[5px] flex w-full items-center gap-2 px-2.5 py-[5px] m-0 font-medium text-xs leading-[130%] relative cursor-pointer no-underline"
                  >
                    <span className="flex h-[30px] w-[30px] shrink-0 items-center justify-center">
                      <SixDots className="h-3.5 w-3.5 shrink-0 text-foreground-muted" />
                    </span>
                    <span className="min-w-0 flex-1 leading-7">View all organizations</span>
                  </RouterLink>
                </li>
                {me.canCreateOrganizations === false ? null : (
                  <li className="h-9 cursor-pointer text-foreground-muted text-base hover:bg-surface-muted flex flex-row">
                    <button
                      type="button"
                      onClick={handleCreateOrganization}
                      className="text-foreground-muted rounded-[5px] flex w-full items-center gap-2 px-2.5 py-[5px] m-0 font-medium text-xs leading-[130%] relative cursor-pointer text-left"
                    >
                      <span className="flex h-[30px] w-[30px] shrink-0 items-center justify-center">
                        <AddBlue stroke="currentColor" className="h-3.5 w-3.5 shrink-0" />
                      </span>
                      <span className="min-w-0 flex-1 leading-7 whitespace-nowrap text-ellipsis overflow-hidden">
                        Create new organization
                      </span>
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </div>
        ) : null}
      </ClickAway>
    </div>
  );
};
